import { useEffect, useState } from "react";
import { ChevronDown, Phone } from "lucide-react";

const HeroSection = ({ onReservar }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden hero-bg"
      style={{
        backgroundImage: `url('https://images.unsplash.com/photo-1550966871-3ed3cbe818b5?w=1920&q=80')`,
      }}
      data-testid="hero-section"
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-[#0a0a0a]/75" />

      {/* Radial gold glow */}
      <div
        className="absolute inset-0"
        style={{ background: 'radial-gradient(ellipse at 30% 60%, rgba(212,175,55,0.08) 0%, transparent 70%)' }}
      />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 w-full pt-20">
        <div className="max-w-3xl">
          {/* Pre-title */}
          <div
            className={`flex items-center gap-4 mb-8 transition-all duration-700 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
          >
            <div className="h-px w-12 bg-gold" />
            <span className="text-gold text-xs tracking-[0.4em] uppercase font-body">Ansoáin, Navarra</span>
          </div>

          {/* Main title */}
          <h1
            className={`font-heading font-bold text-5xl md:text-7xl text-[#ededed] leading-none mb-6 transition-all duration-700 delay-100 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            Restaurante
            <br />
            <span className="gold-shimmer italic">Neli</span>
          </h1>

          {/* Subtitle */}
          <p
            className={`font-body text-[#a3a3a3] text-lg md:text-xl max-w-xl leading-relaxed mb-10 transition-all duration-700 delay-200 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            Cocina familiar con sabor auténtico. Ingredientes frescos, platos preparados con dedicación y un ambiente donde te sentirás como en casa.
          </p>

          {/* CTAs */}
          <div
            className={`flex flex-col sm:flex-row gap-4 transition-all duration-700 delay-300 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            <button
              data-testid="hero-reservar-btn"
              onClick={onReservar}
              className="bg-gold text-black font-bold text-xs tracking-widest uppercase px-8 py-4 rounded-[20px] hover:bg-gold-dark transition-all duration-300 hover:-translate-y-0.5"
            >
              Reservar Mesa
            </button>
            <a
              href="tel:948595567"
              className="border border-gold text-gold text-xs font-bold tracking-widest uppercase px-8 py-4 rounded-[20px] hover:bg-gold hover:text-black transition-all duration-300 flex items-center gap-2 justify-center"
              data-testid="hero-phone-btn"
            >
              <Phone size={14} />
              948 59 55 67
            </a>
          </div>

          {/* Stats */}
          <div
            className={`mt-16 flex gap-10 transition-all duration-700 delay-400 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            {[
              { num: '20–30€', label: 'precio medio' },
              { num: '22:00', label: 'horario cierre' },
              { num: '100%', label: 'cocina casera' },
            ].map((stat) => (
              <div key={stat.label} className="flex flex-col">
                <span className="font-heading text-2xl text-gold font-bold">{stat.num}</span>
                <span className="text-[#a3a3a3] text-xs tracking-widest uppercase">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-[#a3a3a3] text-xs tracking-widest uppercase">Scroll</span>
        <ChevronDown size={16} className="text-gold" />
      </div>
    </section>
  );
};

export default HeroSection;
